var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    stroke: "#848491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91671 12.75V11.5833C9.91671 10.9645 9.67087 10.371 9.23329 9.93342C8.7957 9.49583 8.20221 9.25 7.58337 9.25H2.91671C2.29787 9.25 1.70438 9.49583 1.26679 9.93342C0.829207 10.371 0.583374 10.9645 0.583374 11.5833V12.75",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24996 6.91667C6.53862 6.91667 7.58329 5.872 7.58329 4.58333C7.58329 3.29467 6.53862 2.25 5.24996 2.25C3.96129 2.25 2.91663 3.29467 2.91663 4.58333C2.91663 5.872 3.96129 6.91667 5.24996 6.91667Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 12.75V11.5833C13.4162 11.0663 13.2442 10.5641 12.9274 10.1555C12.6107 9.74689 12.1672 9.45505 11.6666 9.32581",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 2.32581C9.83528 2.45431 10.2801 2.74621 10.5978 3.15549C10.9155 3.56476 11.0879 4.06812 11.0879 4.58622C11.0879 5.10432 10.9155 5.60769 10.5978 6.01696C10.2801 6.42623 9.83528 6.71813 9.33337 6.84664",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/new-user.56fa0c430755e101966aaf981dacbd38.svg";
export { ForwardRef as ReactComponent };